import createjs from 'createjs-module'

import { Spots } from './../spots/Spots'
import {Spot, SpotModelViewDto} from './spot/Spot'

import {
    EVENT_TYPE_ADD_SPOTS_GRID_COMPLETED,
    EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS,
    EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED,

    dispatchEventType, dispatchEventDataType,
} from '../../../../globals/EventDispatcher'
import { Dimensions } from '../../../../globals/Dimensions';
import {FlyerFrameSettingDto, FlyerPageDto, FlyerPageSpotDto, FrameIconDataDto} from '../../../../dtos';

import {
    FLYER_SPOTS_MIN_HEIGHT_PX,
    FLYER_SPOTS_MIN_WIDTH_PX,
    getCanvasElementsScales,
} from '../../../../globals'


export class SpotsFunctions{

    private _mainSpotsContainer: Spots | null = null;

    constructor(spotsContainer: Spots) {
        this._mainSpotsContainer = spotsContainer;
    }

    public deleteSelectedSpots() {

        let mainContainer = this._mainSpotsContainer!
        let innerSpots = mainContainer.innerSpots

        let deletedSpotsDtos: FlyerPageSpotDto[] = []

        for (let i = 0; i < innerSpots.length; i++) {
            const spot = innerSpots[i];

            if(spot.isSelected) 
            {
                spot.parent.removeChild(spot)
                let currentDeletedSpots = innerSpots.splice(i, 1);
                
                let currentDeletedSpotsDtos = currentDeletedSpots.map((spot) => {
                    let updatedData = spot.updatedData!
                    updatedData.isForDeletion = true;
                    return updatedData
                })

                deletedSpotsDtos = [
                    ...deletedSpotsDtos,
                    ...currentDeletedSpotsDtos
                ]

                --i;
            }
        }

        // if no frames selected
        if(!this.hasSelectedSpots()) {
            dispatchEventType(EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED)
        }

        if(innerSpots.length === 0){
            let t = "";
        }

        mainContainer.updateStage();

        mainContainer.persistenceManager?.prepareSpotsForSaving(deletedSpotsDtos);
    }

    public selectAllPageSpots(value: boolean, isIgnoreUnselectAll?: boolean) {

        let mainContainer = this._mainSpotsContainer!
        let innerSpots = mainContainer.innerSpots

        let totalSelected = 0;

        for (let i = 0; i < innerSpots.length; i++) {
            const spot = innerSpots[i];

            spot.setSelected(value);
            spot.updateLabelPosition();
            spot.updateIconPosition();
            spot.updateFrameIconImage(spot._frameIconData && spot._frameIconData.type ? spot._frameIconData.type : 1)

            if(value) {
                totalSelected++;
            }
        }

        // if no frames selected
        if(!value && !isIgnoreUnselectAll) {
            dispatchEventType(EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED)
        }
        else {
            if(totalSelected > 0){
                dispatchEventDataType(EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS, totalSelected === innerSpots.length)
            }
        }
        
        mainContainer.updateStage();
    }

    public selectFrameUsingFrameDataFromRightPanel(selectedFrame: FlyerPageSpotDto) {
        let mainContainer = this._mainSpotsContainer!;
        let innerSpots = mainContainer.innerSpots;
        let isSelected = false;
        let totalSelected = 0;

        for (let i = 0; i < innerSpots.length; i++) {
            const spot = innerSpots[i];
            isSelected = spot._data?.fpsRecId === selectedFrame.fpsRecId;
            if(isSelected){
                spot.setSelected(isSelected, mainContainer._isDisabledZoom);
                mainContainer.addChild(spot);
            }

            if(isSelected) {
                totalSelected++;
            }
        }

        // if no frames selected
        if(!totalSelected) {
            dispatchEventType(EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED)
        }
        else {
            if(totalSelected > 0){
                dispatchEventDataType(EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS, totalSelected === innerSpots.length)
            }
        }

        mainContainer.updateStage();
    }

    public hasSelectedSpots(){

        let mainContainer = this._mainSpotsContainer
        let innerSpots = mainContainer!.innerSpots

        for (let i = 0; i < innerSpots.length; i++) {
            const spot = innerSpots[i];

            if(spot.isSelected){
                return true;
            }
        }

        return false;
    }

    public selectedSpots(){
        let selectedSpotsArray = [];
        let mainContainer = this._mainSpotsContainer
        let innerSpots = mainContainer!.innerSpots

        for (let i = 0; i < innerSpots.length; i++) {
            const spot = innerSpots[i];
            if(spot.isSelected){
                selectedSpotsArray.push(spot._data);
            }
        }

        return selectedSpotsArray;
    }

    public selectedSpotsDataFromCanvas(){
        let selectedSpotsArray = [];
        let mainContainer = this._mainSpotsContainer
        let innerSpots = mainContainer!.innerSpots

        for (let i = 0; i < innerSpots.length; i++) {
            const spot = innerSpots[i];
            if(spot.isSelected){
                selectedSpotsArray.push(spot);
            }
        }

        return selectedSpotsArray;
    }

    public putSelectedSpotsChildrenOnTop() {

        let mainContainer = this._mainSpotsContainer!

        for (let i = 0; i < mainContainer.innerSpots.length; i++) {
            const spot = mainContainer.innerSpots[i];

            if (spot.isSelected) {
                mainContainer.addChild(spot)
            }
        }
    }

    public extractSpotsFromTheirContainer(currentSpotsContainer: Spots) {

        let mainContainer = this._mainSpotsContainer!

        if(!currentSpotsContainer) {
            return;
        }

        let createdSpotsDtos: FlyerPageSpotDto[] = []

        const x0 = currentSpotsContainer.x;
        const y0 = currentSpotsContainer.y;

        let totalSpots = 0;
        for (let i = 0; i < currentSpotsContainer.children.length; i++) {
            const child = currentSpotsContainer.children[i];
            
            if (child instanceof Spot) {
                const childDimensions = child.getBounds();
                child.x = x0 + child.x;
                child.y = y0 + child.y;
                mainContainer.addChild(child)
                totalSpots++;
                --i;

                mainContainer.innerSpots.push(child);

                createdSpotsDtos.push(child.updatedData)
            }
        }     

        //
        mainContainer.currentSpotsContainer!.innerSpots = [];
        mainContainer.currentSpotsContainer = null;

        //
        mainContainer.persistenceManager?.prepareSpotsForSaving(createdSpotsDtos);
    }

    public createSpot = (spotIndex: number, dimensions: Dimensions, frameIconData?: FrameIconDataDto, isSelectedSpot?: boolean): Spot => {
        let mainContainer = this._mainSpotsContainer!

        var spot = new Spot(mainContainer)
        spot.init(spotIndex, dimensions, frameIconData, isSelectedSpot)
        spot.setPosition(dimensions.x!, dimensions.y!)
        spot.x = dimensions.x!;
        spot.y = dimensions.y!;

        return spot;
    }

    public hasAllSpotsSelected(){

        let mainContainer = this._mainSpotsContainer!

        if(!mainContainer.isPageContainer) {
            return this.hasSpotsContainerSelected(mainContainer);
        }

        //
        if(mainContainer.innerSpots.length === 0){
            return false;
        }

        let isAllSelected: boolean = true;

        for (let i = 0; i < mainContainer.innerSpots.length; i++) {
            const spot = mainContainer.innerSpots[i];

            if(!spot.isSelected){
                isAllSelected = false;
            }
        }

        return isAllSelected;
    }

    public hasSpotsContainerSelected(container: Spots) {

        let totalSelected = 0;

        for (let i = 0; i < container.children.length; i++) {
            const child = container.children[i]

            if(child instanceof Spot) {
                if(child.isSelected) {
                    totalSelected++;
                }
            }
        }

        // Shape + Spot
        if(container.children.length === 2) {
            if(totalSelected === 1) {
                return true;
            }
        }

        return false;
    }

    public createRedStroke(x: number, y: number, width: number, height: number): createjs.Shape {
        let shape = new createjs.Shape();

        shape.graphics
            .setStrokeStyle(2)
            .setStrokeDash([10, 10])
            .beginStroke('red')
            .drawRect(0, 0, width, height)
            .endFill();

        shape.x = x;
        shape.y = y;

        return shape
    }

    public initSpotsDtos(flyerPageDto: FlyerPageDto, originalPageWidth: number, originalPageHeight: number, isHorizontalOrientationForFrames: boolean, isSelectedAllFramesModeOn: boolean, selectedFrames?: FlyerPageSpotDto[]) {
        let spotsDtos: FlyerPageSpotDto[] = flyerPageDto.flyerPageSpots!
        let modelViewDtos: SpotModelViewDto[] = []
        for (let i = 0; i < spotsDtos.length; i++) {
            const dto = spotsDtos[i];
            dto.hasNumber = true;
            modelViewDtos.push({
                dto: dto,
                spot: undefined
            })
        }

        let reOrderedDtos = this.getReorderedSpotsDtos(modelViewDtos, isHorizontalOrientationForFrames);

        let mainContainer = this._mainSpotsContainer!

        mainContainer.innerSpots = []

        // TODO: we need to keep it globaly and not calculate it each time
        let scaleX = mainContainer.pageWidth / flyerPageDto.flpWidthPx!
        let scaleY = mainContainer.pageHeigth / flyerPageDto.flpHeightPx!


        for (let i = 0; i < reOrderedDtos.length!; i++) {
            const mvDto: SpotModelViewDto = reOrderedDtos[i];
            const spotDto = mvDto.dto!
            
            // when we test for collision we use also equality
            // so to avoid collision between spots we need to add initial
            // smal gap/offset
            let offset = 0.001

            let dimensions: Dimensions = {
                x: (spotDto.fpsX0px! + offset) * scaleX,
                y: (spotDto.fpsY0px! + offset) * scaleY,
                width: (spotDto.fpsWidthPx! - 2.0 * offset) * scaleX,
                height: (spotDto.fpsHeightPx! - 2.0 * offset) * scaleY
            }

            let frameIconData: FrameIconDataDto = {
                iconXPercentageNumber: spotDto.fpsIconXPct ? spotDto.fpsIconXPct : 50,
                iconYPercentageNumber: spotDto.fpsIconYPct ? spotDto.fpsIconYPct : 50,
                type: spotDto.fpsFrameType ? spotDto.fpsFrameType : 1
            }
            let isSelectedSpot = false;
            if(selectedFrames && selectedFrames.length > 0){
                const findSelectedSpot = selectedFrames.find((frame: FlyerPageSpotDto) => frame.fpsRecId === spotDto.fpsRecId);
                if(findSelectedSpot){
                    isSelectedSpot = true;
                }
            }
            let spot = this.createSpot(i + 1, dimensions, frameIconData, isSelectedSpot);
            spot.x = dimensions.x!;
            spot.y = dimensions.y!;

            //
            let dto: FlyerPageSpotDto = {
                ...spotDto,
                fpsX0px: dimensions.x,
                fpsY0px: dimensions.y,
                fpsWidthPx: dimensions.width,
                fpsHeightPx: dimensions.height
            }
            spot.initialData = dto;
            if(i === 0 && (selectedFrames && selectedFrames.length === 0)){
                spot.setSelected(true, mainContainer._isDisabledZoom);
            }


            if(isSelectedAllFramesModeOn){
                spot.setSelected(true, mainContainer._isDisabledZoom);
            }

            //
            mainContainer.addChild(spot)
            mainContainer.innerSpots.push(spot)
        }
    }

    public getMinimalSpotDimensions(): Dimensions {
        let realFlyerWidth = this._mainSpotsContainer!._flyerPageDto?.flpWidthPx!
        let realFlyerHeight = this._mainSpotsContainer!._flyerPageDto?.flpHeightPx!

        let scale = getCanvasElementsScales(realFlyerWidth, realFlyerHeight);

        let minWidth = FLYER_SPOTS_MIN_WIDTH_PX * scale.scaleX;
        let minHeight = FLYER_SPOTS_MIN_HEIGHT_PX * scale.scaleY;

        let dimensions: Dimensions = { width: minWidth, height: minHeight }

        return dimensions;
    }

    public getNextGridMinimalDimensions(nextGgridSize: Dimensions): Dimensions {
        var rows = nextGgridSize.y!;
        var columns = nextGgridSize.x!;

        let realFlyerWidth = this._mainSpotsContainer!._flyerPageDto?.flpWidthPx!
        let realFlyerHeight = this._mainSpotsContainer!._flyerPageDto?.flpHeightPx!

        let scale = getCanvasElementsScales(realFlyerWidth, realFlyerHeight);

        let minWidth = FLYER_SPOTS_MIN_WIDTH_PX * scale.scaleX;
        let minHeight = FLYER_SPOTS_MIN_HEIGHT_PX * scale.scaleY;

        let gridWidth = columns * minWidth;
        let gridHeight = rows * minHeight;

        let dimensions: Dimensions = { width: gridWidth, height: gridHeight }

        return dimensions;
    }

    public addInitialGrid(mouseX: number, mouseY: number): Spots {

        let mainContainer = this._mainSpotsContainer!

        var rows = mainContainer.nextGgridSize!.y!;
        var columns = mainContainer.nextGgridSize!.x!;

        let realFlyerWidth = this._mainSpotsContainer!._flyerPageDto?.flpWidthPx!;
        let realFlyerHeight = this._mainSpotsContainer!._flyerPageDto?.flpHeightPx!;

        let scale = getCanvasElementsScales(realFlyerWidth, realFlyerHeight);

        let minWidth = FLYER_SPOTS_MIN_WIDTH_PX * scale.scaleX;
        let minHeight = FLYER_SPOTS_MIN_HEIGHT_PX * scale.scaleY;

        //
        let innerSpotsContainer = new Spots(false, columns * minWidth, rows * minHeight)
        innerSpotsContainer.innerSpots = []

        // when we test for collision we use also equality
        // so to avoid collision between spots we need to add initial
        // smal gap/offset
        let offset = 0.001

        for (let y = 0; y < rows; y++) {

            for (let x = 0; x < columns; x++) {

                // none zero based
                var index = (y * columns + x) + 1
                
                let dimensions = {
                    x: x * (minWidth + offset),
                    y: y * (minHeight + offset),
                    width: minWidth - 2.0 * offset,
                    height: minHeight - 2.0 * offset,
                }

                let frameIconData: FrameIconDataDto = {
                    iconXPercentageNumber: 50,
                    iconYPercentageNumber: 50,
                    type: 1
                }

                let spot = this.createSpot(index, dimensions, frameIconData)
                spot.showLabel(false);
                spot.showIcon(false);

                //
                let dto: FlyerPageSpotDto = {
                    fpsX0px: dimensions.x,
                    fpsY0px: dimensions.y,
                    fpsWidthPx: dimensions.width,
                    fpsHeightPx: dimensions.height
                }
                spot.initialData = dto;

                innerSpotsContainer.addChild(spot)
                innerSpotsContainer.innerSpots.push(spot)
            }
        }

        innerSpotsContainer.x = mouseX;
        innerSpotsContainer.y = mouseY;

        // to avoid gliches before starting dragging
        // in the dragging function we set visible to true
        // for the case where it is visible false
        innerSpotsContainer.visible = false;

        mainContainer.addChild(innerSpotsContainer);
        mainContainer.updateStage()

        mainContainer.currentSpotsContainer = innerSpotsContainer;

        //
        dispatchEventType(EVENT_TYPE_ADD_SPOTS_GRID_COMPLETED)

        return innerSpotsContainer;
    }

    public getReorderedSpotsDtos(spotsDto: SpotModelViewDto[], isHorizontal?: boolean) {
        if (spotsDto.length === 0) {
            return spotsDto;
        }
        let ordered: SpotModelViewDto[] = [];
    
        spotsDto.sort((mvA: SpotModelViewDto, mvB: SpotModelViewDto) => {

            let a = mvA.dto!
            let b = mvB.dto!
            if(isHorizontal){
                if (a.fpsY0px! < b.fpsY0px!) {
                    return -1
                }
                else if (a.fpsY0px! > b.fpsY0px!) {
                    return 1
                }
                else {
                    return 0
                }

            } else {
                if (a.fpsX0px! < b.fpsX0px!) {
                    return -1
                }
                else if (a.fpsX0px! > b.fpsX0px!) {
                    return 1
                }
                else {
                    return 0
                }
            }
        })
    
        let itemsGroupedByY = new Array<Array<SpotModelViewDto>>();
        if (!itemsGroupedByY[0]) {
            itemsGroupedByY[0] = new Array<SpotModelViewDto>();
        }
        itemsGroupedByY[0].push(spotsDto[0])
    
        var index = 0;
        for (let i = 0; i < spotsDto.length - 1; i++) {
            const currentSpot = spotsDto[i];
            const nextSpot = spotsDto[i + 1];
    
            if (!itemsGroupedByY[index]) {
                itemsGroupedByY[index] = new Array<SpotModelViewDto>();
            }
    
            if (currentSpot.dto!.fpsY0px! === nextSpot.dto!.fpsY0px!) {
                itemsGroupedByY[index].push(nextSpot)
            }
            else {
                index++;
                if (!itemsGroupedByY[index]) {
                    itemsGroupedByY[index] = new Array<SpotModelViewDto>();
                }
                itemsGroupedByY[index].push(nextSpot)
            }
        }
    
        for (let j = 0; j < itemsGroupedByY.length; j++) {
            const goupe = itemsGroupedByY[j];
            goupe.sort((mvA: SpotModelViewDto, mvB: SpotModelViewDto) => {
                let a = mvA.dto!
                let b = mvB.dto!
                if(isHorizontal){
                    if (a.fpsX0px! < b.fpsX0px!) {
                        return -1
                    }
                    else if (a.fpsX0px! > b.fpsX0px!) {
                        return 1
                    }
                    else {
                        return 0
                    }
                } else {
                    if (a.fpsY0px! < b.fpsY0px!) {
                        return -1
                    }
                    else if (a.fpsY0px! > b.fpsY0px!) {
                        return 1
                    }
                    else {
                        return 0
                    }
                }
            })
        }
    
        for (let i = 0; i < itemsGroupedByY.length; i++) {
            const group = itemsGroupedByY[i];
    
            for (let j = 0; j < group.length; j++) {
                const spot = group[j];
                ordered.push(spot)
            }
    
        }
    
        return ordered;
    }

    public getModelViewDtos(): SpotModelViewDto[] 
    {
        let mainContainer = this._mainSpotsContainer!

        let spotsDtos: SpotModelViewDto[] = []

        for (let i = 0; i < mainContainer.innerSpots.length; i++) {
            const spot = mainContainer.innerSpots[i];
            const spotBounds = spot.getBounds();

            let spotDto: FlyerPageSpotDto | null;

            if(spot.initialData) {
                spotDto = spot.initialData
            }
            else {
                spotDto = {
                    fpsX0px: spot.x,
                    fpsY0px: spot.y,
                    fpsWidthPx: spotBounds.width,
                    fpsHeightPx: spotBounds.height
                }
            }

            spot.initialData = spotDto

            spotsDtos.push({
                dto: spotDto,
                spot: spot
            })
        }

        return spotsDtos;
    }

    public getSelectedSpots(selected: boolean): Spot[] {
        let mainContainer = this._mainSpotsContainer!

        let selectedSpots: Spot[] = []

        for (let i = 0; i < mainContainer.innerSpots.length; i++) {
            const spot = mainContainer.innerSpots[i];

            if(selected){
                if(spot.isSelected){
                    selectedSpots.push(spot)
                }
            }
            else {
                if(!spot.isSelected){
                    selectedSpots.push(spot)
                }
            }
        }

        return selectedSpots;
    }

    public showSpotsLabel(value: boolean){
        let mainContainer = this._mainSpotsContainer!

        for (let i = 0; i < mainContainer.innerSpots.length; i++) {
            const innerSpotsContainer = mainContainer.innerSpots[i];

            for (let j = 0; j < innerSpotsContainer.children.length; j++) {
                const child = innerSpotsContainer.children[j];
                if (child instanceof Spot) {
                    child.showLabel(value);
                }
            }
        }
    }

    public reNumberAllSpots(isHorizontal: boolean){
        let mainContainer = this._mainSpotsContainer!
        let spotsDtos: SpotModelViewDto[] = this.getModelViewDtos();
        let reOrderedDtos = this.getReorderedSpotsDtos(spotsDtos, isHorizontal);

        for (let i = 0; i < reOrderedDtos.length; i++) {
            const mvDto: SpotModelViewDto = reOrderedDtos[i];
            mvDto.spot!.text = `${i + 1}`;
            mvDto.spot!.showLabel(true);
            mvDto.spot!._frameIconData = {
                iconXPercentageNumber: Number(mvDto.dto?.fpsIconXPct),
                iconYPercentageNumber: Number(mvDto.dto?.fpsIconYPct),
                type: Number(mvDto.dto?.fpsFrameType)
            }
            mvDto.spot!.updateFrameIconImage(mvDto.dto && mvDto.dto.fpsFrameType ? mvDto.dto.fpsFrameType : 1);
            mvDto.spot!.showIcon(true);
        }

        mainContainer.updateStage();

        //
        let itemsToSave: FlyerPageSpotDto[] = reOrderedDtos.map(mvDto => {
            let dto = mvDto.spot!.updatedData
            return dto
        })
        mainContainer.persistenceManager?.prepareSpotsForSaving(itemsToSave)
    }

    public reNumberAllSpotsWithDataForSelectedFrames(selectedFrames: FlyerPageSpotDto[], newState: FlyerFrameSettingDto, isHorizontalOrientationForFrames: boolean){
        let mainContainer = this._mainSpotsContainer!

        let spotsDtos: SpotModelViewDto[] = this.getModelViewDtos();
        let reOrderedDtos = this.getReorderedSpotsDtos(spotsDtos, isHorizontalOrientationForFrames);

        for (let i = 0; i < reOrderedDtos.length; i++) {
            const mvDto: SpotModelViewDto = reOrderedDtos[i];

            mvDto.spot!.text = `${i + 1}`;
            mvDto.spot!.showLabel(true);
            mvDto.spot!.showIcon(true);
            const selectedFrameDto = selectedFrames.find((frame) => frame.fpsY0px === mvDto.spot!._data!.fpsY0px && frame.fpsX0px === mvDto.spot?._data?.fpsX0px);
            if(selectedFrameDto){
                mvDto.spot!._data = {
                    ...mvDto.spot!._data,
                    ...newState
                }
                if(newState.fpsFrameType){
                    mvDto.spot!.updateFrameIconImage(newState.fpsFrameType);
                }
                mvDto.spot!._frameIconData = {
                    iconXPercentageNumber: Number(newState.fpsIconXPct),
                    iconYPercentageNumber: Number(newState.fpsIconYPct),
                    type: Number(newState.fpsFrameType)
                }
            }

        }
        mainContainer.updateStage();

        //
        let itemsToSave: FlyerPageSpotDto[] = reOrderedDtos.map(mvDto => {
            let dto = mvDto.spot!.updatedData
            return dto
        })
        mainContainer.persistenceManager?.prepareSpotsForSaving(itemsToSave)
    }

    public changeIconDataForSelectedFrames(data: FrameIconDataDto){
        let mainContainer = this._mainSpotsContainer!
        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        for (let i = 0; i < selectedSpots.length; i++) {
            const selectedSpot = selectedSpots[i];
            selectedSpot.updateLabelPosition(data);
            selectedSpot.updateIconPosition(data);
            selectedSpot.updateFrameIconImage(data.type!);
            let minimalSpotDimensions = mainContainer!.spotsFunctions!.getMinimalSpotDimensions()
            let inputWidth =  selectedSpot._label?.getBounds().width;
            let inputHeight = selectedSpot._label?.getBounds().height;
            // let inputWidth =  minimalSpotDimensions.width!
            // let inputHeight = minimalSpotDimensions.height!
            selectedSpot._input!.style.height = `${inputHeight}px`;
            selectedSpot._input!.style.width = `${inputWidth}px`;
            selectedSpot._input!.style.left = selectedSpot._label?.x! + 'px';
            selectedSpot._input!.style.top = selectedSpot._label?.y! + 'px';
            // const {iconYPercentageNumber, iconXPercentageNumber} = selectedSpot._frameIconData!;
            // if(iconYPercentageNumber && iconXPercentageNumber){
            //     if(iconYPercentageNumber >= 40 && iconYPercentageNumber <= 60 && iconXPercentageNumber >= 40 && iconXPercentageNumber <= 60){
            //         selectedSpot._input!.style.top = (selectedSpot._originalHeight * scaleY - inputHeight) * 0.5 + 35 + 'px';
            //
            //     }
            // }

            // const mvDto: SpotModelViewDto = selectedSpots[i];
            //
            // mvDto.spot!.text = `${i + 1}`;
            // mvDto.spot!.showLabel(true);
            // mvDto.spot!.showIcon(true);
            // const selectedFrameDto = selectedFrames.find((frame) => frame.fpsY0px === mvDto.spot!._data!.fpsY0px && frame.fpsX0px === mvDto.spot?._data?.fpsX0px);
            // if(selectedFrameDto){
            //     mvDto.spot!._data = {
            //         ...mvDto.spot!._data,
            //         ...newState
            //     }
            //     if(newState.fpsFrameType){
            //         mvDto.spot!.updateFrameIconImage(newState.fpsFrameType);
            //     }
            // }

        }
        // mainContainer.updateStage();

    }

    public reNumberFrom(isHorizontal: boolean){
        let mainContainer = this._mainSpotsContainer!

        let selectedSpots = this.getSelectedSpots(true);
        if(selectedSpots.length === 0){
            alert('no spot selected, please select one.')
            return;
        }
        else if(selectedSpots.length > 1) {
            alert('to renumber from, please select only one spot.')
            return;
        }

        let fromSelectedSpot = selectedSpots[0];
        let minimumIndex: number = Number.parseInt(fromSelectedSpot.text);

        let spotsDtos: SpotModelViewDto[] = this.getModelViewDtos();
        let reOrderedDtos = this.getReorderedSpotsDtos(spotsDtos, isHorizontal);

        let hasFoundSelectedSpot = false;
        let index = 0;
        let notReorderingSpots = [];
        for (let i = 0; i < reOrderedDtos.length; i++) {
            const mvDto: SpotModelViewDto = reOrderedDtos[i];

            if(mvDto.spot === fromSelectedSpot) {
                hasFoundSelectedSpot = true;
            }

            if(hasFoundSelectedSpot) {
                const someOfNumberFrameAlreadyExistAndCantBeChange = notReorderingSpots.some((noChangeMvDto) => {
                    return noChangeMvDto.spot!.text === (index + minimumIndex).toString();
                })
                if(!someOfNumberFrameAlreadyExistAndCantBeChange){
                    mvDto.spot!.text = `${index + minimumIndex}`;
                    mvDto.spot!.showLabel(true);
                    mvDto.spot!._frameIconData = {
                        iconXPercentageNumber: Number(mvDto.dto?.fpsIconXPct),
                        iconYPercentageNumber: Number(mvDto.dto?.fpsIconYPct),
                        type: Number(mvDto.dto?.fpsFrameType)
                    }
                    index++;
                } else {
                    while(true){
                        const someOfNumberFrameAlreadyExistAndCantBeChange = notReorderingSpots.some((noChangeMvDto) => {
                            return noChangeMvDto.spot!.text === (index + minimumIndex).toString();
                        })
                        if(someOfNumberFrameAlreadyExistAndCantBeChange){
                            index = index + 1
                        } else {
                            break;
                        }
                    }
                    mvDto.spot!.text = `${index + minimumIndex}`;
                    mvDto.spot!.showLabel(true);
                    mvDto.spot!._frameIconData = {
                        iconXPercentageNumber: Number(mvDto.dto?.fpsIconXPct),
                        iconYPercentageNumber: Number(mvDto.dto?.fpsIconYPct),
                        type: Number(mvDto.dto?.fpsFrameType)
                    }
                    index++;
                }
            } else {
                notReorderingSpots.push(mvDto);
            }
        }

        mainContainer.updateStage();

        //
        let itemsToSave: FlyerPageSpotDto[] = reOrderedDtos.map(mvDto => {
            let dto = mvDto.spot!.updatedData
            return dto
        })
        mainContainer.persistenceManager?.prepareSpotsForSaving(itemsToSave)
    }

    public hasPositionNumberAlreadyExist(spot: Spot, newPositionNumber: number){
        let mainContainer = this._mainSpotsContainer!
        let innerSpots = mainContainer.innerSpots

        for (let i = 0; i < innerSpots.length; i++) {
            const currentSpot = innerSpots[i];
            const currentPositionNumber = currentSpot.initialData?.fpsPositionNo;

            if(currentSpot === spot) {
                continue;
            }

            if(currentPositionNumber && currentPositionNumber === newPositionNumber) {
                return true;
            }
        }
        return false;
    }

}